import { FC } from 'react';
import { Link } from 'react-router-dom';
import { CodeBlock } from '@/components/ui/CodeBlock';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';

interface ConfigurationProps {
  systemId: string;
  claudeApiUrl?: string;
  openaiApiUrl?: string;
}

export const Configuration: FC<ConfigurationProps> = ({ claudeApiUrl }) => {
  // 使用API返回的完整URL，如果没有则使用fallback
  const baseUrl = claudeApiUrl || `你的API_URL如（http://xx.xx.xx.xx:8080）`;
  const manualEnvConfig = `ANTHROPIC_BASE_URL="${baseUrl}"
ANTHROPIC_AUTH_TOKEN="你的API_KEY"`;
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">配置 API Key</h2>
        <p className="text-gray-600 leading-relaxed">
          配置白茆AI的API密钥，开启强大的AI编程辅助功能。
        </p>
      </div>

      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">🔑 获取API密钥</h3>
        
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-medium text-blue-900 mb-2">购买服务后获取密钥</h4>
            <ol className="text-sm text-blue-800 space-y-1 list-decimal list-inside">
              <li>联系客服购买白茆AI服务套餐</li>
              <li>客服将为您提供专属API密钥</li>
              <li>按照下方配置步骤设置密钥</li>
            </ol>
          </div>
          
          <div className="text-center">
            <Button as={Link} to="/contact">
              立即联系客服购买
            </Button>
          </div>
        </div>
      </Card>

      <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">⚙️ 配置环境变量</h3>
        
        <div className="space-y-6">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h4 className="font-medium text-green-900 mb-2">📌 您选择的系统配置</h4>
            <div className="text-sm text-green-800 space-y-2">
              <p><strong>API地址:</strong> <code className="bg-green-100 px-2 py-1 rounded text-xs">{baseUrl}</code></p>
            </div>
          </div>
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900">配置系统环境变量</h4>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <p className="text-sm text-gray-700 mb-3">
                确保添加以下环境变量到您的系统配置文件：
              </p>
              <CodeBlock
                code={manualEnvConfig}
                title="环境变量配置"
              />
            </div>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h4 className="font-medium text-yellow-900 mb-2">⚠️ 重要说明</h4>
            <ul className="text-sm text-yellow-800 space-y-1 list-disc list-inside">
              <li>配置完成后需要重启终端或重新加载配置文件</li>
              <li>请妥善保管您的API密钥，不要泄露给他人</li>
              <li>环境变量名称必须严格按照上述格式配置</li>
            </ul>
          </div>
        </div>
      </Card>

      {/* <Card>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">📞 联系客服</h3>
        
        <div className="text-center p-6">
          <p className="text-gray-600 mb-4">
            如有任何疑问，请随时联系我们的技术支持团队
          </p>
          <div className="bg-primary-50 rounded-lg p-4">
            <p className="text-primary-900 font-semibold text-lg mb-2">客服热线</p>
            <p className="text-primary-700 font-mono text-xl">18689477277</p>
          </div>
        </div>
      </Card> */}

      <div className="bg-gradient-to-r from-primary-600 to-accent-500 rounded-lg p-6 text-white">
        <h3 className="text-lg font-semibold mb-2">🎉 配置完成！</h3>
        <p className="text-primary-100 mb-4">
          恭喜您已完成所有配置！现在可以开始使用白茆AI进行高效的编程工作了。
        </p>
        <div className="flex gap-3">
          <CodeBlock
            code="claude "
            title="输入claude 后一直回车，然后输入 ： hello 查看是否可以正确返回内容"
          />
        </div>
      </div>
    </div>
  );
};